import { Component, Vue, Prop } from "vue-property-decorator";
import template from "./rim-repair-logout-confirm.template.vue";
import { Logout } from "@/api";

@Component({
  mixins: [template]
})
export default class RimRepairLogoutConfirmComponent extends Vue {
  @Prop({ default: false }) state!: boolean;
  public loading = false;

  close() {
    this.$emit("close");
  }

  async logout() {
    try {
      this.loading = true;
      const resp = await Logout();
      this.loading = false;
      if (resp.Ok) {
        this.$router.push("/logout");
      }
    } catch (err) {
      //
    }
  }
}
